<div data-testid="bed-type-cell" class="cell">
  <goab-text #bedTypeTextHeading tag="h3" size="body-m" mt="none" mb="none"
    ><span class="bold-text"
      >Type {{ dataEntryRow().bedType.name }}</span
    ></goab-text
  >
  <goab-text #bedTypesubTextHeading tag="h4" size="body-s" mt="none" mb="none"
    ><span class="bold-text"
      >Formerly {{ dataEntryRow().bedType.formerly }}:</span
    ></goab-text
  >
  <goab-text
    #bedTypeDescriptionHeading
    size="body-xs"
    tag="span"
    mt="none"
    mb="none"
    >{{ bedTypeDescription() }}</goab-text
  >
</div>

<div data-testid="funded-beds-cell" class="cell count-column">
  {{ dataEntryRow().fundedBeds }}
</div>
<div
  data-testid="operational-beds-cell"
  class="cell count-column"
  [ngClass]="{
    'input-count-column': status() !== capacityReportStatus.COMPLETED
  }"
>
  @if(status() && status() === capacityReportStatus.COMPLETED) {
  {{ dataEntryRow().operationalBeds }}
  }@else {
  <goab-form-item [error]="operationalBedsValidation().errorMessage ?? ''">
    <goab-input
      addClick
      size="compact"
      [row]="index()"
      [col]="'Operational'"
      [attr.data-testid]="'operational-beds-input-' + index()"
      [attr.id]="'operational-beds-input-' + index()"
      cycleTabBoundary
      [cycleIsFirst]="isFirstOperationalField()"
      [cycleFirstSelector]="'#operational-beds-input-0'"
      [cycleLastSelector]="'#occupied-beds-input-' + (totalRows() - 1)"
      [error]="operationalBedsValidation().hasError"
      type="number"
      width="10ch"
      name="item"
      [value]="dataEntryRow().operationalBeds ?? null"
      (onBlur)="onOperationalBedsBlur($any($event))"
      (onChange)="onOperationalBedsChange($any($event))"
      (tabDirection)="tabDirection.emit($any($event))"
      (click)="fieldSelection.emit($any($event))"
      (onFocus)="updateFocusState('operational', true)"
    ></goab-input>
  </goab-form-item>

  } @if(hasOperationalFootnote()) {
  <goab-text
    #operationalFootnoteText
    data-testid="operational-footnote-text"
    size="body-xs"
    tag="span"
    mt="none"
    mb="none"
    >Last week’s input:
    {{ dataEntryRow().previousOperationalBeds ?? 0 }}</goab-text
  >
  }
</div>
<div
  data-testid="occupied-beds-cell"
  class="cell count-column"
  [ngClass]="{
    'input-count-column': status() !== capacityReportStatus.COMPLETED
  }"
>
  @if(status() && status() === capacityReportStatus.COMPLETED) {
  {{ dataEntryRow().occupiedBeds }}
  }@else {
  <goab-form-item [error]="occupiedBedsValidation().errorMessage ?? ''">
    <goab-input
      addClick
      size="compact"
      [row]="index()"
      [col]="'Occupied'"
      [attr.data-testid]="'occupied-beds-input-' + index()"
      [attr.id]="'occupied-beds-input-' + index()"
      cycleTabBoundary
      [cycleIsLast]="isLastOccupiedField()"
      [cycleFirstSelector]="'#operational-beds-input-0'"
      [cycleLastSelector]="'#occupied-beds-input-' + (totalRows() - 1)"
      type="number"
      width="10ch"
      [error]="occupiedBedsValidation().hasError"
      name="item"
      [value]="dataEntryRow().occupiedBeds ?? null"
      (onBlur)="onOccupiedBedsBlur($any($event))"
      (onChange)="onOccupiedBedsChange($any($event))"
      (tabDirection)="tabDirection.emit($any($event))"
      (click)="fieldSelection.emit($any($event))"
      (onFocus)="updateFocusState('occupied', true)"
    ></goab-input>
  </goab-form-item>

  }@if(hasOccupiedFootnote()) {
  <goab-text
    #occupiedFootnoteText
    data-testid="occupied-footnote-text"
    size="body-xs"
    tag="span"
    mt="none"
    mb="none"
    >Last week’s input:
    {{ dataEntryRow().previousOccupiedBeds ?? 0 }}</goab-text
  >
  }
</div>
@if(!showVacancy()) {
<div data-testid="vacancy-cell" class="cell count-column">-</div>
} @else {
<div data-testid="vacancy-cell" class="cell count-column">
  {{ vacancy() }}
</div>
}
